'use client'

import Head from 'next/head'
import { useRouter } from 'next/router'

import useAsset from 'hooks/useAsset'

import HrefLangTags from './HrefLangTags'

type Props = {
  url?: string
  locale?: string
}

const AppHead = ({ url, locale }: Props) => {
  const router = useRouter()
  const asset = useAsset('assets/favicon/default')

  /* Query parameters are stripped from canonical URL */
  let canonical = router.asPath.split('#')[0]!.split('?')[0]
  /* Removes trailing slash for the root page */
  if (url) canonical = new URL(url).origin + (router.asPath === '/' ? '' : canonical)

  const page = Number(router.query.page)
  if (page > 2) canonical += `?page=${page}`

  return (
    <Head>
      <meta name="accept-language" content={locale} />
      <meta charSet="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />

      <link rel="canonical" href={canonical} />

      <HrefLangTags url={url} />

      <link rel="apple-touch-icon" sizes="180x180" href={asset('apple-touch-icon.png')} />
      <link rel="icon" type="image/png" sizes="32x32" href={asset('favicon-32x32.png')} />
      <link rel="icon" type="image/png" sizes="16x16" href={asset('favicon-16x16.png')} />
      <link rel="shortcut icon" href={asset('/favicon.ico')} />
    </Head>
  )
}

export default AppHead
